import{validateSafeContent as t}from"../internal/idValidation.js";class i{constructor(i){this.idAsString=i,t(i)}serialize(){return this.toString()}toString(){return this.idAsString}}export{i as ValidatedSafeString};
